import React, { Component } from 'react';
import * as d3 from 'd3';

class PieChart2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      arc: null,
      pie: null,
      hoveredName: ''
    };
    
    
  }

  componentDidMount() {
    this.setState({
      data: this.props.data,
      arc: this.createArc(),
      pie: this.createPie(),
      colors: this.createColors()
    });
  }
  
  createArc() {
    const height = this.props.height;
    const width = this.props.width;
    const radius = Math.min(width, height) / 2;
    return d3
      .arc()
      .innerRadius(radius * 0.67)
      .outerRadius(radius - 1)
      .cornerRadius(4);
  }
  
  createPie() {
    return d3
      .pie()
      .sort(null)
      .value(d => d.count);
  }
  
  createColors() {
    return d3
      .scaleOrdinal()
      .domain(this.state.data.map(d => d.name))
      .range(this.props.colorRange);
  }

  handleMouseEnter(){
    // todo show tooltip
  }
  
  handleMouseLeave(){
    // todo hide tooltip
  }
  
  render() {
    const { width, height } = this.props;
    const { colors, arc, pie, data } = this.state;

    if (!arc || !pie || !colors ) {
      return <div>Loading...</div>;
    }
    
    return (
      <React.Fragment>
        <svg height="250px" width="300px">
          <g id={this.props.id} style={{margin: 'auto',transform: "translate(50%, 50%)"}} transform={`translate(${width / 2}, ${height / 2})`}>
            { pie(data).map( d => {
              return(
                <path key={d.data.name} fill={colors(d.data.name)} d={arc(d)} stroke={"white"}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}/>
              )
            })}
          </g>
        </svg>
        <div className="tooltip">
          <div className="tooltip-text alert">
            {this.state.hoveredName}
          </div>
        </div>
      </React.Fragment>
    )
    
  }
}
export default PieChart2;